import { DatePipe } from '@angular/common';
import { Component, Input, OnInit, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ALERT_TYPE } from 'src/app/constants';
import { Enums } from 'src/app/Shared/enums';
import { SharedService } from 'src/app/Shared/shared-service.service';
import { EPF } from 'src/model/epf.model';
import { EpfService } from 'src/services/epf.service';
import { LoanService } from 'src/services/loan.service';
import { TransactionService } from 'src/services/transaction.service';

@Component({
    selector: 'app-edit-epf-details',
    templateUrl: './edit-epf-details.component.html',
    styleUrls: ['./edit-epf-details.component.scss'],
    providers: [DatePipe],
    standalone: false
})
export class EditEpfDetailsComponent implements OnInit {
  private activeModal = inject(NgbActiveModal);
  protected sharedService = inject(SharedService);
  private enums = inject(Enums);
  private epfService = inject(EpfService);
  private loanService = inject(LoanService);
  private transactionService = inject(TransactionService);

  @Input() customerId: number;
  @Input() profileId: number;
  @Input() epfDetails: EPF;
  @Input() dob: Date;
  withEPFDate = false;

  allowEdit = false;

  disableSubmit = false;

  async ngOnInit(): Promise<void> {
    await this.getCustomerEPF();

    this.allowEdit = (this.sharedService.isAdmin() || this.sharedService.isBossAccount()) ? true : await this.allowToEditCrucialEPFDetails()
  }

  async getCustomerEPF() {
    try {
      this.epfDetails = await this.epfService.getCustomerEPF(this.customerId);
    } catch (error) {
      this.reset();
    }
  }

  async updateEPFDetails() {
    const epf: EPF = Object.assign(new EPF(), this.epfDetails);
    if (this.allowEdit == false) {
      epf.Date = undefined;
      epf.Amount = undefined;
    }
    this.disableSubmit = true;
    try {
      await this.epfService.updateCustomerEPF(this.customerId, epf);
      this.sharedService.openAlert("Successfully updated customer details", ALERT_TYPE.SUCCESS);
      this.reset();
      window.location.reload();
    } finally {
      this.disableSubmit = false;
    }
  }

  async allowToEditCrucialEPFDetails() {
    //Conditions for BM to edit crucial epf details : epf date & epf amount
    // 1. SETTLED all EPF loans more than 1 month (last payment > 1 month)
    // 2. Last set epf date > 2 years
    // 3. Without any unsettled EPF loan

    const comparedDaysDiff = 365 * 2;
    const lastEPFDate = new Date(this.epfDetails.Date.getFullYear(), this.epfDetails.Date.getMonth(), this.epfDetails.Date.getDate());
    const today = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());
    const diff = Math.abs(today.getTime() - lastEPFDate.getTime())
    const diffDays = Math.ceil(diff / (1000 * 3600 * 24));

    const unsettledEPFLoans = await this.loanService.getCustomerLoans(this.customerId, { schemes: ['EPF'], status: [this.enums.ACTIVE_LOAN, this.enums.WARNING_LOAN, this.enums.CP_LOAN, this.enums.BAD_DEBT_LOAN] });

    const startDate = new Date(new Date().getFullYear(), new Date().getMonth() - 1, new Date().getDate());
    const paymentsWithinMonth = await this.transactionService.getProfileLoansTransactions(this.profileId, { startDate: startDate.toISOString(), endDate: new Date().toISOString(), types: [this.enums.REPAYMENT] });

    if (diffDays > comparedDaysDiff && unsettledEPFLoans.length == 0 && paymentsWithinMonth.length == 0)
      return true;
    else
      return false;
  }

  reset() {
    this.activeModal.close();
  }
}
